"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAcceptanceStatusFilterItemComponent = exports.renderUserFilterItemComponent = void 0;
// filterRenderers.tsx
const React = __importStar(require("react"));
const search_filter_items_1 = require("./search-filter-items");
const Actions = __importStar(require("../actions"));
const renderUserFilterItemComponent = (props) => {
    // Implement your custom filter component here
    return (React.createElement(search_filter_items_1.InputFilterComponent, { value: props.filterItemsStates.userItemState.selectedUser, disabled: !props.filterItemsStates.userItemState.filterEnabled, onChange: value => {
            props.dispatch(Actions.setFilterItemsState(Object.assign(Object.assign({}, props.filterItemsStates), { userItemState: Object.assign(Object.assign({}, props.filterItemsStates.userItemState), { selectedUser: value }) })));
        } }, "Username"));
};
exports.renderUserFilterItemComponent = renderUserFilterItemComponent;
const renderAcceptanceStatusFilterItemComponent = (props) => {
    return (React.createElement(search_filter_items_1.ListFilterComponent, { values: [
            { id: "1", name: "Accepted" },
            { id: "0", name: "Rejected" }
        ], selectedValues: props.filterItemsStates.acceptanceStatusItemState.selectedStatus.map(x => x.toString()), disabled: !props.filterItemsStates.acceptanceStatusItemState.filterEnabled, onChange: e => {
            props.dispatch(Actions.setFilterItemsState(Object.assign(Object.assign({}, props.filterItemsStates), { acceptanceStatusItemState: Object.assign(Object.assign({}, props.filterItemsStates.acceptanceStatusItemState), { selectedStatus: filterSelectedValues(e.target).map(s => Number.parseInt(s, 10)) }) })));
        } }));
};
exports.renderAcceptanceStatusFilterItemComponent = renderAcceptanceStatusFilterItemComponent;
function filterSelectedValues(selectElement) {
    return Array.from(selectElement.options)
        .filter(o => o.selected)
        .map(o => o.value);
}
//# sourceMappingURL=filter-component-renderers.js.map